import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getDashboardKYCCard, getUserAddress } from '../../api';
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { AddressList } from '../address/addressList';
import { goToLink, loginLogout } from '../../projectData';
import { VoucherRedemConfirm } from './voucherSubmitConfirm';
import { useRouteData } from '../../RouteDataContext';
import { FullPageLoader } from '../../../component/helper';

const RedemTransectionType = () => {
    const location = useLocation();
    const { userData } = useRouteData();
    const navigate = useNavigate()
    const item = location.state?.itemValue;

    const [addressArray, setAddressArray] = useState([]);
    const [bankData, setBankData] = useState([]);
    const [loading, setLoading] = useState(false); // 🔹 loader state

    useEffect(() => {
        if (!userData) return;
        if (userData) {
            setLoading(true); // start loader
            Promise.all([
                getDashboardKYCCard(userData?.user?.iirpl_sap_code),
                getUserAddress({ user_code: userData?.user?.iirpl_sap_code })
            ])
                .then(([bank, address]) => {
                    setBankData(bank);
                    setAddressArray(address.data);
                })
                .catch((err) => {
                    loginLogout(err.response)
                    console.error("Error fetching redemption data:", err);
                })
                .finally(() => setLoading(false)); // stop loader
        }
    }, [userData]);

    const renderGiftType = () => {
        switch (item?.gift_type) {
            case 1:
            case 6:
                return (
                    <AddressList
                        addressArray={addressArray}
                        selectedItem={item}
                        user_code={userData?.user?.iirpl_sap_code}
                    />
                );
            case 2:
                return (
                    <div className='container'>
                        {(bankData && bankData?.bank_detail_id) ? (
                            <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0 col-lg-6 col-xxl-4 mt-4">
                                <div
                                    onClick={() =>
                                        bankData?.bank_verified === 1 &&
                                        goToLink(
                                            navigate,
                                            `/customer/redem-detail/re-confirm/${userData?.user?.iirpl_sap_code}`,
                                            { itemValue: item, detailData: bankData }
                                        )
                                    }
                                    className="card_outer"
                                    style={{ backgroundColor: '#39533a' }}
                                >
                                    <div className="d-flex align-items-center">
                                        <div className="icon_box">
                                            <img width="20" alt="icon" src={toAbsoluteUrl("/media/images/bank.png")} />
                                        </div>
                                        <p className="px-2 mb-0 text-white">Bank Account</p>
                                        <span className="text-white d-flex justify-content-end w-50">
                                            <i className="bi bi-chevron-right"></i>
                                        </span>
                                    </div>
                                    <div className="verified_bankdetails">
                                        <p className="text-white">Bank Name: {bankData?.api_bankName}</p>
                                        <p className="text-white">Branch: {bankData?.api_branch}</p>
                                        <p className="text-white">City: {bankData?.api_city}</p>
                                        <p className="text-white">Name at Bank: {bankData.api_nameAtBank}</p>
                                        <p className="text-white">Reference Id: {bankData?.api_refId}</p>
                                    </div>
                                    {bankData?.bank_verified === 1 ? (
                                        <p className="text-white mb-1 status_data verified_details">Verified</p>
                                    ) : bankData?.bank_verified === 0 ? (
                                        <div className="d-flex justify-content-between">
                                            <span className="text-white mb-1 status_data verify_rejected">Rejected</span>
                                            <Link to={`/customer/addbank-detail/${userData?.user?.iirpl_sap_code}`}>
                                                <span style={{ background: '#506B51' }} className="py-2 px-2 rounded text-white">
                                                    <i className="bi bi-plus text-white"></i> Add Other
                                                </span>
                                            </Link>
                                        </div>
                                    ) : (
                                        <p className="text-white mb-1 status_data verify_pending">Verification Pending</p>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0 col-lg-6 col-xxl-4">
                                <div className="card_outer bank-cardbg">
                                    <div className="d-flex align-items-center">
                                        <div className="icon_box">
                                            <img width="20" alt="icon" src={toAbsoluteUrl("/media/images/bank.png")} />
                                        </div>
                                        <p className="px-2 mb-0 text-white">Bank Account</p>
                                    </div>
                                    <Link to={`/customer/addbank-detail/${userData?.user?.iirpl_sap_code}`}>
                                        <p className="bg-lightgreen text-center text-white py-15 mb-0 mt-8 add_cards">
                                            <i className="bi bi-plus text-white"></i> Add Bank Account
                                        </p>
                                    </Link>
                                </div>
                            </div >
                        )}
                    </div >
                );
            case 3:
                return <VoucherRedemConfirm selectedItem={item} userData={userData} />;
            default:
                return (
                    <div style={{ background: '#fefafa' }} className='card vh-100 mb-4'>
                        <div className='card-body p-4'>
                            <div className="notice d-flex bg-light-danger rounded border-primary border border-dashed mt-5 mb-9 p-6">
                                <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                    <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-danger' />
                                </span>
                                <div className="d-flex flex-stack flex-grow-1">
                                    <div className="fw-semibold">
                                        <div className="fs-6 text-gray-700 gap-3">No product type found</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
        }
    };

    return (
        <div className='vh-100 '>
            {loading ? (
                <FullPageLoader />
            ) : (
                item && item?.gifts_id ? renderGiftType() : <p>No item data</p>
            )}
        </div>
    )
}

export default RedemTransectionType

